module.exports = {"pricing_hero_icon":{"src":"pricing_icon.png","src_2x":"pricing_icon@2x.png","width":"202","height":"268"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/default/setting/pricing/media.json
// module id = 504
// module chunks = 0 1 2 3 4 5